<div class="card" [class.disabled]="$disabled()" tabindex="0" #cardContainer>
  <!-- Header with pagination -->
  <div class="header">
    <span class="title">{{ $currentQuestion().question }}</span>
    <div class="pagination">
      @if ($totalQuestions() > 1) {
        <button class="page-nav" (click)="goPrev()" [disabled]="$isFirst() || $disabled()" [attr.aria-label]="'Previous question'">
          <i class="fa-regular fa-chevron-left"></i>
        </button>
        <span class="page-count">{{ $currentIndex() + 1 }} of {{ $totalQuestions() }}</span>
        <button class="page-nav" (click)="goNext()" [disabled]="$isLast() || $disabled()" [attr.aria-label]="'Next question'">
          <i class="fa-regular fa-chevron-right"></i>
        </button>
      }
      <button class="close-btn" (click)="onCancel()" [disabled]="$disabled()" [attr.aria-label]="'Close'">
        <i class="fa-regular fa-xmark"></i>
      </button>
    </div>
  </div>

  <!-- Body -->
  <div class="body">
    @switch ($currentQuestion().mode) {
      @case ('single') {
        @for (option of $currentQuestion().options; track option.label; let i = $index) {
          <div class="option-row"
               [class.active]="$selectedIndex() === i"
               [class.focused]="$focusedIndex() === i"
               (click)="onRadioSelect(i)"
               (mouseenter)="$focusedIndex.set(i)">
            <wb-radio size="medium" tabindex="-1" [checked]="$selectedIndex() === i" [disabled]="$disabled()" />
            <div class="option-text">
              <span class="option-label">{{ option.label }}</span>
              @if (option.description) {
                <span class="option-description">{{ option.description }}</span>
              }
            </div>
          </div>
        }
        @if ($freetextAllowed()) {
          <div class="option-row freetext-row"
               [class.active]="$freetextSelected()"
               [class.focused]="$focusedIndex() === $freetextRowIndex()"
               (click)="onSelectFreetextRow()"
               (mouseenter)="$focusedIndex.set($freetextRowIndex())">
            <wb-radio size="medium" tabindex="-1" [checked]="$freetextSelected()" [disabled]="$disabled()" />
            <input #freetextInput type="text" class="freetext-input" placeholder="Something else"
                   [value]="$customText()"
                   (input)="onFreetextInput($any($event.target).value)"
                   (focus)="onFreetextFocus()"
                   (click)="$event.stopPropagation()"
                   [disabled]="$disabled()" />
          </div>
        }
      }

      @case ('multiple') {
        @for (option of $currentQuestion().options; track option.label; let i = $index) {
          <div class="option-row"
               [class.active]="$checkedIndices().has(i)"
               [class.focused]="$focusedIndex() === i"
               (click)="onCheckboxToggle(i)"
               (mouseenter)="$focusedIndex.set(i)">
            <wb-checkbox size="medium" tabindex="-1" [checked]="$checkedIndices().has(i)" [disabled]="$disabled()" />
            <div class="option-text">
              <span class="option-label">{{ option.label }}</span>
              @if (option.description) {
                <span class="option-description">{{ option.description }}</span>
              }
            </div>
          </div>
        }
        @if ($freetextAllowed()) {
          <div class="option-row freetext-row"
               [class.active]="$customText().trim().length > 0"
               [class.focused]="$focusedIndex() === $freetextRowIndex()"
               (mouseenter)="$focusedIndex.set($freetextRowIndex())">
            <wb-checkbox size="medium" tabindex="-1" [checked]="$customText().trim().length > 0" [disabled]="$disabled()" />
            <input type="text" class="freetext-input" placeholder="Something else"
                   [value]="$customText()"
                   (input)="onFreetextInput($any($event.target).value)"
                   (focus)="onFreetextFocus()"
                   [disabled]="$disabled()" />
          </div>
        }
      }

      @case ('rank') {
        <div cdkDropList (cdkDropListDropped)="onDrop($event)">
          @for (option of $rankedOptions(); track option.label; let i = $index) {
            <div class="rank-row" cdkDrag>
              <span class="grip-handle" cdkDragHandle>
                <i class="fa-regular fa-grip-lines"></i>
              </span>
              <span class="rank-label">{{ option.label }}</span>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- Footer (unified across all modes) -->
  <div class="footer">
    @if ($currentQuestion().mode === 'multiple' && $selectionCount() > 0) {
      <span class="selection-count">{{ $selectionCount() }} selected</span>
    } @else {
      <span class="spacer"></span>
    }

    <div class="footer-actions">
      @if ($totalQuestions() > 1) {
        <wb-button displayStyle="Tertiary"
                   label="Skip"
                   [disabled]="$disabled()"
                   (onClick)="skipCurrent()" />
      }
      <wb-button displayStyle="Primary"
                 [label]="$isLast() ? 'Send' : 'Next'"
                 [iconRight]="$isLast() ? 'fa-regular fa-arrow-turn-down-left' : 'fa-regular fa-arrow-right'"
                 [disabled]="$disabled() || !$canSend()"
                 (onClick)="onPrimaryAction()" />
    </div>
  </div>
</div>
